import React from "react";

// Per-section safety net (Premium rule 1A-5): if a panel throws during render,
// show a retry card for THAT panel only instead of blanking the whole page.
export class SectionErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(err, info) { try { console.error("Premium section error:", err, info); } catch { /* ignore */ } }
  reset = () => this.setState({ hasError: false });
  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-2xl border border-amber-400/30 bg-white/[0.03] p-6 text-center" data-testid="section-error">
          <p className="text-white/80">Something went wrong here.</p>
          <button onClick={this.reset} className="mt-4 rounded-full bg-amber-400 px-5 py-2 text-sm font-semibold text-black">Tap to retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default SectionErrorBoundary;
